export const disableErrorIfJest = (error: unknown) => {
    // if we re testing and the error is 'fetch is not defined', we don't want to display it because it's normal
    if (process.env.JEST_WORKER_ID === undefined) {
        console.error(error);
    }
};
